import { Component, Input } from '@angular/core';

@Component({
	selector: 'signup-check-email',
	template: require('./signup-check-email.component.html'),
	styles: [require('./signup-check-email.component.scss')]
})
export class SignupCheckEmailComponent {
	@Input() firstName: string;
	@Input() textHtml: string;
	@Input() titleHtml: string;

	constructor() {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/login/signup-check-email/signup-check-email.component.ts